import $ from '../vendor/jquery';
import Swiper from '../vendor/swiper';

$(function () {
  var mySwiper = new Swiper ('.slider', {
    loop: true,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 4000,
    },
  })
});



// WEBPACK FOOTER //
// ./public/assets/js/src/components/slider.js